export default __webpack_public_path__ + "static/media/external-link.e4002939.svg";